import { useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

import { bannerBgImgStyle } from './ContestAndWinnersStyles';
import GameTab from './GameTab';
import {
  parseGameMapperId,
  triggerContestWinnerPageEvent
} from 'src/utils/watchAndWinUtils';

const ContestsAndWinners = () => {
  const searchParams = useSearchParams();
  const gameMapperId = parseGameMapperId(
    searchParams.get('game_mapper_id') || ''
  );

  const backgroundImage =
    '/webapp-assets/images/ILT/WinnerList_Creative_PWA.png';

  useEffect(() => {
    triggerContestWinnerPageEvent(gameMapperId as string);
  }, []);

  return (
    <div>
      {backgroundImage && (
        <img
          css={[bannerBgImgStyle]}
          src={backgroundImage}
          alt="Winners Background Image"
        />
      )}
      <GameTab />
    </div>
  );
};

export default ContestsAndWinners;
